import {
  createComponent,
  createElement,
  ref,
  watch,
} from "@vue/composition-api";
import { Input } from "element-ui";
import Decimal from "decimal.js";

interface Props {
  value: Decimal;
  precision: number;
  clearable: boolean;
}

export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true },
    precision: { default: 2 },
    clearable: { default: false, type: Boolean },
  },
  setup(props, ctx) {
    const numberText = ref<string>("");

    watch(
      () => props.value,
      (newValue) => {
        if (!newValue) numberText.value = "";
        else numberText.value = newValue.toFixed(props.precision);
      },
    );

    const on = {
      ...ctx.listeners,
      input: (val: string) => {
        val = val.replace(",", ".");
        val = val.replace(/[^0-9.]+/gm, "");
        const parts = val.split(".");
        if (parts.length > 1) val = parts.shift() + "." + parts.join("");
        numberText.value = val;
      },
      change: (val: string) => {
        if (!val) {
          if (props.clearable) ctx.emit("input", null);
          else ctx.emit("input", new Decimal(0));
          return;
        }

        const decValue = new Decimal(val).toDecimalPlaces(props.precision);
        ctx.emit("input", decValue);
      },
    };

    return () =>
      createElement(Input, {
        on,
        props: {
          value: numberText.value,
          clearable: props.clearable,
          ...ctx.attrs,
        },
      });
  },
});
